import { SkyscannerLocationtagsserviceApiV1 } from '@skyscanner-internal/location-tags-service-web-http-client';

import { grpcFetchClientWrapper } from '../../internals/clients/grpc/grpc';

export const GRPC_LOCATION_TAGS_CLIENT_NAME = 'LOCATION_TAGS_GET';
export const PATH_PREFIX = '/g/location-tags-service';

export const locationTagsRequest = grpcFetchClientWrapper(
  SkyscannerLocationtagsserviceApiV1.LocationTagService.GetLocationTags,
  {
    clientName: GRPC_LOCATION_TAGS_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
  },
);
